import {Formik} from 'formik';

import {FormComponent} from './FormComponent';

import {RecordSchema} from './RecordSchema';
import {toFormikValidationSchema} from 'zod-formik-adapter';

import {FormWithButtons} from '@flexinet/ui-components';

import {BillableUnit} from '../types';
import {stage} from "../../../config/stage";

export const RecordForm = ({
                               record,
                               handleSubmit,
                               handleCancel,
                           }: {
    record: Omit<BillableUnit, 'id'>,
    handleSubmit: (values: BillableUnit) => Promise<unknown>,
    handleCancel?: () => void
}) => {

    // Returns the save promise, so Formik keeps isSubmitting true (and the Save button
    // disabled) until the server answers (§6). A synchronous handler clears it on the
    // same tick and leaves double-submit live.
    const onSubmit = (values: BillableUnit) => handleSubmit(values);

    const onCancel = () => {
        handleCancel?.();
    };

    let initialValues = {} as BillableUnit;

    if (record) {
        initialValues = Object.assign({}, initialValues, record);
    }

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={toFormikValidationSchema(RecordSchema)}
            onSubmit={onSubmit}
        >
            {({
                  handleSubmit,
                  isSubmitting,
                  ...rest
              }) => (
                <FormWithButtons handleSubmit={handleSubmit} isSubmitting={isSubmitting}
                                 handleCancel={onCancel} debug={false && stage === 'ide'} {...rest}  >
                    <FormComponent/>
                </FormWithButtons>)}
        </Formik>
    );
};
